type UseIsLeadershipManagementEnabled = () => boolean;
export const useIsLeadershipManagementEnabled: UseIsLeadershipManagementEnabled = () => true;
